export default __webpack_public_path__ + "static/media/ic_logo_text.233c08b2.png";